/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Enumerates the options for how columns animate into view.
 */
export var ColumnShowingAnimationMode = /*@__PURE__*/ (function (ColumnShowingAnimationMode) {
    /**
     * Automatically selects the correct animation mode.
     */
    ColumnShowingAnimationMode[ColumnShowingAnimationMode["Auto"] = 0] = "Auto";
    /**
     * No animation should be performed.
     */
    ColumnShowingAnimationMode[ColumnShowingAnimationMode["None"] = 1] = "None";
    /**
     * Cells slide in from the left.
     */
    ColumnShowingAnimationMode[ColumnShowingAnimationMode["SlideFromLeft"] = 2] = "SlideFromLeft";
    /**
     * Cells slide in from the right.
     */
    ColumnShowingAnimationMode[ColumnShowingAnimationMode["SlideFromRight"] = 3] = "SlideFromRight";
    /**
     * Cells slide in from the top.
     */
    ColumnShowingAnimationMode[ColumnShowingAnimationMode["SlideFromTop"] = 4] = "SlideFromTop";
    /**
     * Cells slide in from the bottom.
     */
    ColumnShowingAnimationMode[ColumnShowingAnimationMode["SlideFromBottom"] = 5] = "SlideFromBottom";
    /**
     * Cells fade in.
     */
    ColumnShowingAnimationMode[ColumnShowingAnimationMode["FadeIn"] = 6] = "FadeIn";
    /**
     * Cells slide in from the left and fade in.
     */
    ColumnShowingAnimationMode[ColumnShowingAnimationMode["SlideFromLeftAndFadeIn"] = 7] = "SlideFromLeftAndFadeIn";
    /**
     * Cells slide in from the right and fade in.
     */
    ColumnShowingAnimationMode[ColumnShowingAnimationMode["SlideFromRightAndFadeIn"] = 8] = "SlideFromRightAndFadeIn";
    /**
     * Cells slide in from the top and fade in.
     */
    ColumnShowingAnimationMode[ColumnShowingAnimationMode["SlideFromTopAndFadeIn"] = 9] = "SlideFromTopAndFadeIn";
    /**
     * Cells slide in from the bottom and fade in.
     */
    ColumnShowingAnimationMode[ColumnShowingAnimationMode["SlideFromBottomAndFadeIn"] = 10] = "SlideFromBottomAndFadeIn";
    return ColumnShowingAnimationMode;
})({});
/**
 * @hidden
 */
export var ColumnShowingAnimationMode_$type = /*@__PURE__*/ markEnum('ColumnShowingAnimationMode', 'Auto,0|None,1|SlideFromLeft,2|SlideFromRight,3|SlideFromTop,4|SlideFromBottom,5|FadeIn,6|SlideFromLeftAndFadeIn,7|SlideFromRightAndFadeIn,8|SlideFromTopAndFadeIn,9|SlideFromBottomAndFadeIn,10');
//# sourceMappingURL=ColumnShowingAnimationMode.js.map
